import React from 'react'

function Home() {

  return (
    <section className="" >
        <div className="d-flex justify-content-center"> <p className='p-5 display-5'>JunJie Wu</p> </div>
    
        <div className="d-flex justify-content-center"> <p className='display-6'>Welcome To My Page!</p> </div>

    </section>
  )
}

export default Home